import { useEffect } from 'react'

const PDF_URL = '/adium/dicasen.pdf'

export function DicasenPage() {
  useEffect(() => {
    const prev = document.title
    document.title = 'AV Dicasen 2026'
    return () => {
      document.title = prev
    }
  }, [])

  return (
    <div className="fixed inset-0 h-full w-full bg-gray-100 dark:bg-background">
      <object data={PDF_URL} type="application/pdf" className="h-full w-full">
        <iframe src={PDF_URL} title="AV Dicasen 2026" className="h-full w-full border-0" />
        <div className="flex h-full w-full items-center justify-center p-6 text-center">
          <p className="text-sm text-gray-600 dark:text-gray-300">
            No se pudo mostrar el PDF en el navegador.{' '}
            <a href={PDF_URL} className="text-[#57a6d8] underline" target="_blank" rel="noopener noreferrer">
              Descargar AV Dicasen 2026
            </a>
          </p>
        </div>
      </object>
    </div>
  )
}
